import React, { useState, useEffect, useRef } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';
import * as d3 from 'd3';
import axios from 'axios';

export default function Conversion(props) {
    const { ...rest } = props;

    // Chakra Color Mode
    const cardColor = useColorModeValue('white', 'navy.700');
    const cardShadow = useColorModeValue(
        '0px 18px 40px rgba(112, 144, 176, 0.12)',
        'unset'
    );

    const [imageBase64, setImageBase64] = useState("");
    const [error, setError] = useState(null); // Initialize error state

    const data = [
        { name: "Group A", coeff: -0.4 },
        { name: "Group B", coeff: 2.1 },
        { name: "Group C", coeff: 1 }
        // ... add more data points as needed
    ];

    const width = 400;
    const height = 300;
    const margin = { top: 20, right: 20, bottom: 30, left: 50 };

    const ref = useRef();

    useEffect(() => {
        // Check if selectedOption is not null and has a value field
        if (props.selectedOption && props.selectedOption.value) {
            // Use the selectedOption.value in the API URL
            // const apiUrl = `http://localhost:8000/api/get-survival-multivars-hr/?project=${props.selectedOption.value}`;
            // const apiUrl = `http://localhost:8000/api/get-crosstalk-enrichment/?project=${props.selectedOption.value}`;
            // const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
            // const apiUrl = `${api_host}/api/get-survival-multivars-hr/?project=${props.selectedOption.value}`;


            // axios.get(apiUrl)
            //     .then(response => {
            //         setImageBase64(response.data.image_base64);
            //     })
            //     .catch(err => {
            //         setError("Failed to fetch image."); // Set error state
            //         console.error("Error fetching image: ", err);
            //     });

            const svg = d3.select(ref.current);

            data.sort((a, b) => b.coeff - a.coeff);


            const plotWidth = width * (2 / 3);

            const y = d3.scaleBand()
                .domain(data.map(d => d.name))
                .range([margin.top, height - margin.bottom])
                .padding(0.4);

            const x_lower = Math.min(d3.min(data, d => d.coeff), -1) * 1.1
            const x_upper = Math.max(d3.max(data, d => d.coeff), 1) * 1.1
            const x = d3.scaleLinear()
                .domain([x_lower, x_upper])
                // adjust xScale to start from the halfway point
                .range([width / 3 + margin.left, width - margin.right]);

            svg.selectAll("rect")
            .data(data)
            .enter().append("rect")
            .attr("x", d => d.coeff >= 0 ? x(0) : x(d.coeff))
            .attr("y", d => y(d.name) - y.bandwidth() / 2) // Adjusting to center the bar on y coordinate
            .attr("width", d => Math.abs(x(d.coeff) - x(0)))
            .attr("height", y.bandwidth()) // Using bandwidth of the y-scale to set bar height
            .style("fill", "steelblue");

            svg.selectAll("text")
                .data(data)
                .enter().append("text")
                .attr("x", width * (1 / 3) + margin.left / 2)
                .attr("y", d => y(d.name))
                .attr("dy", "0.35em")
                .attr("text-anchor", "end")
                .text(d => d.name);

            svg.append("g")
                .attr("transform", `translate(0,${height - margin.bottom})`)
                .call(d3.axisBottom(x).ticks(5));


            const yAxis = d3.axisRight(y).tickSize(0);
            svg.append("g")
                .attr("transform", `translate(${width / 3 + margin.left},0)`)
                .call(yAxis)
                .selectAll(".tick text")
                .remove();

            const lineXPosition = x(0);

            svg.append("line")
                .attr("x1", lineXPosition)
                .attr("y1", margin.top)
                .attr("x2", lineXPosition)
                .attr("y2", height - margin.bottom)
                .style("stroke", "black")
                .style("stroke-dasharray", "5,5"); // This creates a dashed pattern of 5px dashes and 5px gaps

            svg
                .append('text')
                .text('Coefficient')
                .style('font-family', 'Arial')
                // .style('font-weight', 'bold')
                .style('font-size', '1rem')
                .style('text-anchor', 'middle')
                .attr('x', width / 3 + plotWidth / 2)
                .attr('y', height );



        }
    }, [height, width, margin, data, props.selectedOption]);

    return (
        <Card p='20px' align='center' direction='column' w='100%' {...rest}>
            <div className="App">
                <Box mb={4}>
                    <h3>Hazard Ratio (Multivariate COX Model)</h3>
                </Box>
                <svg ref={ref} width="100%" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet"></svg>
                {error && <p>{error}</p>} {/* Display error message */}
            </div>
        </Card>
    );
}
